import { render, staticRenderFns } from "./icone-cadastro.vue?vue&type=template&id=d6933cfa"
import script from "./icone-cadastro.vue?vue&type=script&lang=js"
export * from "./icone-cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports